<template>
  <section v-loading.fullscreen.lock="loading" class="count">
    <com-tabs
      :list="statisticsInfo.obj.tabs3"
      class="count-tabs"
      :default-tab="activeTab"
      direction="column"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="count-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>

    <div>
      <com-standard v-show="activeTab == 0" />
      <com-self v-show="activeTab == 1" />
      <com-notice v-show="activeTab == 2" />
    </div>
  </section>
</template>
<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comNotice from './details/comNotice/index.vue'
import comStandard from './details/comStandard/index.vue'
import comSelf from './details/comSelf/index.vue'
export default {
  components: {
    comTabs,
    comNotice,
    comStandard,
    comSelf
  },
  data() {
    return {
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      loading: false
    }
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    changeTab(x, y) {
      this.activeTab = x
    }
  }
}
</script>
<style lang="scss" scoped>
.count {
  @include fun-layout(1);
  display: flex;
  justify-content: center;
  width: 70%;
  margin: 0 auto;
  &-tabs {
    display: flex;
    flex-direction: column;
    margin-right: 18px;

    margin-top: 75px;
    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 60px;
      width: 150px;
      cursor: pointer;
      margin-bottom: 2px;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-left: 4px solid #2f82ff;
      line-height: 20px;
      margin: 20px 0;
    }
  }
  > div {
    height: 100%;
    width: 1100px;
    > section {
      height: 100%;
    }
  }
}
.count-tabs /deep/ .tabs{
   background-color: #fff;
    border-radius: 10px;
}
</style>
